export default __webpack_public_path__ + "static/media/landing-blobs-top.0af23cd1.png";